<template>
  <div class="view persona-reveal" :style="{ '--persona-color': persona.color, '--persona-glow': persona.glowColor }">
    <transition name="reveal" appear>
      <div class="reveal-wrap">
        <p class="pr__eyebrow orbitron">ALTER EGO DEZVĂLUIT</p>

        <div class="pr__badge" :style="{ background: persona.gradient }">
          <span class="orbitron">{{ persona.name.toUpperCase() }}</span>
        </div>

        <h1 class="pr__name orbitron">{{ persona.name }}</h1>
        <p class="pr__tagline">{{ persona.tagline }}</p>
        <p class="pr__desc">{{ persona.description }}</p>

        <div class="pr__device">
          <div class="pr__device-shape" :style="{ background: persona.gradient }">
            <div class="pr__device-shine"></div>
            <div class="pr__device-label orbitron">VEEV</div>
            <div class="pr__device-ring"></div>
          </div>
          <div class="pr__device-glow" :style="{ background: `radial-gradient(ellipse, ${persona.glowColor} 0%, transparent 70%)` }"></div>
        </div>

        <button class="neon-btn pr__btn" @click="proceed">
          GENEREAZĂ POZA TA
        </button>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useSessionStore } from '@/store/session'
import { PERSONAS } from '@/data/personas'

const router = useRouter()
const session = useSessionStore()

const persona = computed(() => PERSONAS[session.personaId] || PERSONAS.authentic)

function proceed() {
  router.push('/generating')
}
</script>

<style scoped>
.persona-reveal {
  padding: 2rem;
  --persona-color: #7c3aed;
  --persona-glow: rgba(139, 92, 246, 0.6);
}

.reveal-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  text-align: center;
  max-width: 700px;
}

.pr__eyebrow {
  font-size: 0.8rem;
  letter-spacing: 0.4em;
  color: rgba(255, 255, 255, 0.4);
}

.pr__badge {
  padding: 0.5rem 2.5rem;
  border-radius: 4px;
  font-family: 'Orbitron', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.3em;
  color: #fff;
  box-shadow: 0 0 30px var(--persona-glow);
}

.pr__name {
  font-size: clamp(3rem, 8vw, 5.5rem);
  font-weight: 900;
  letter-spacing: 0.08em;
  color: #fff;
  text-shadow: 0 0 40px var(--persona-glow), 0 0 80px var(--persona-glow);
  line-height: 1;
}

.pr__tagline {
  font-size: 1.4rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: var(--persona-color);
}

.pr__desc {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 0.03em;
  max-width: 500px;
}

/* ─── Device visual ─── */
.pr__device {
  position: relative;
  width: 120px;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.5rem 0;
}

.pr__device-shape {
  width: 55px;
  height: 200px;
  border-radius: 12px 12px 8px 8px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 0 30px var(--persona-glow), 0 20px 40px rgba(0,0,0,0.5);
  animation: deviceFloat 4s ease-in-out infinite;
}

.pr__device-shine {
  position: absolute;
  top: 0; left: -30%;
  width: 40%;
  height: 100%;
  background: linear-gradient(135deg, rgba(255,255,255,0.25) 0%, transparent 60%);
}

.pr__device-label {
  position: absolute;
  bottom: 20%;
  left: 50%;
  transform: translateX(-50%) rotate(90deg);
  font-size: 0.55rem;
  letter-spacing: 0.2em;
  color: rgba(255,255,255,0.6);
  white-space: nowrap;
}

.pr__device-ring {
  position: absolute;
  top: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 8px;
  border-radius: 4px;
  background: rgba(0,0,0,0.6);
  border: 1px solid rgba(255,255,255,0.15);
}

.pr__device-glow {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 60px;
  filter: blur(15px);
  opacity: 0.8;
}

@keyframes deviceFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}

.pr__btn {
  border-color: var(--persona-color);
  box-shadow: 0 0 20px var(--persona-glow), inset 0 0 15px rgba(0,0,0,0.1);
}

.pr__btn:active {
  box-shadow: 0 0 40px var(--persona-glow), inset 0 0 20px rgba(0,0,0,0.1);
}

.reveal-enter-active { transition: all 0.7s cubic-bezier(0.22, 1, 0.36, 1); }
.reveal-enter-from { opacity: 0; transform: translateY(40px) scale(0.95); }
</style>
